import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('payment');

export class Accounts extends Api {
  
  constructor(http, config = {}) {
    super(http, url, 'accounts', config);
  }

}